import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function InquirySidebar({ isSidebarOpen }) {
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [formStatus, setFormStatus] = useState(null);

  const toggleInquiry = () => setInquiryOpen(!inquiryOpen);

  const interests = [
    "Renders",
    "Animation Film",
    "Branding",
    "Marketing",
    "Career",
  ];

  const toggleInterest = (item) => {
    setSelectedInterests((prev) =>
      prev.includes(item)
        ? prev.filter((i) => i !== item)
        : [...prev, item]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      contact: e.target.contact.value,
      message: e.target.message.value,
      interests: selectedInterests.join(", "),
    };

    fetch("http://localhost:5000/api/send-inquiry", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setFormStatus("success");
        else setFormStatus("error");
      })
      .catch(() => setFormStatus("error"));

    setTimeout(() => {
      setFormStatus(null);
      e.target.reset();
    }, 3000);
  };

  return (
    <>
      {/* Floating Inquiry Button */}
      {!isSidebarOpen && (
        <div
          className={`fixed top-1/2 z-50 transform -translate-y-1/2 transition-all duration-300 ${
            inquiryOpen ? "sm:right-[322px] right-full" : "right-0"
          }`}
        >
          <button
            onClick={toggleInquiry}
            className="bg-black text-white font-medium hover:bg-gray-700 shadow-lg inline-flex items-center justify-center rounded-l-xl w-8 sm:w-10 lg:w-12 h-28 sm:h-32 lg:h-40"
          >
            <span className="transform rotate-[-90deg] tracking-[0.3rem] text-[0.7rem] sm:text-[0.8rem] lg:text-[0.8rem] font-montserrat font-medium">
              INQUIRY
            </span>
          </button>
        </div>
      )}

      {/* Sidebar Form */}
      <aside
        className={`fixed ${
          inquiryOpen ? "translate-x-0" : "translate-x-full"
        } right-0 top-0 transition-transform duration-300 z-50 w-full h-screen sm:top-1/4 sm:h-[60vh] sm:w-80 bg-white text-black rounded-none sm:rounded-l-3xl overflow-y-auto shadow-lg`}
      >
        <div className="flex justify-end p-3">
          <button
            className="text-black text-xl font-bold"
            onClick={toggleInquiry}
          >
            ✕
          </button>
        </div>

        <div className="px-4 pb-6 text-sm">
          <h2 className="text-lg font-semibold mb-4">Work Inquiry</h2>

          <form className="space-y-2 text-sm" onSubmit={handleSubmit}>
            {/* Name */}
            <label htmlFor="name" className="text-xs font-medium text-gray-600">
              Name*
            </label>
            <input
              id="name"
              name="name"
              type="text"
              placeholder="Your name"
              autoComplete="name"
              required
              className="w-full px-2 py-2 border rounded-md border-gray-300 text-sm focus:outline-none"
            />

            {/* Email */}
            <label htmlFor="email" className="text-xs font-medium text-gray-600">
              Email*
            </label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="Your email"
              autoComplete="email"
              required
              className="w-full px-2 py-2 border rounded-md border-gray-300 text-sm focus:outline-none"
            />

            {/* Phone */}
            <label htmlFor="contact" className="text-xs font-medium text-gray-600">
              Contact*
            </label>
            <PhoneInput
              country={"in"}
              enableSearch
              disableSearchIcon
              inputProps={{
                name: "contact",
                id: "contact",
                required: true,
                autoComplete: "tel",
              }}
              inputStyle={{
                width: "100%",
                height: "34px",
                fontSize: "13px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                backgroundColor: "#f3f3f3",
                color: "#000",
              }}
              dropdownStyle={{
                zIndex: 9999,
                maxHeight: "200px",
                overflowY: "auto",
              }}
            />

            {/* Message */}
            <label htmlFor="message" className="text-xs font-medium text-gray-600">
              Message*
            </label>
            <textarea
              id="message"
              name="message"
              placeholder="Your message"
              rows="3"
              autoComplete="off"
              required
              className="w-full px-2 py-2 border border-gray-300 rounded-md text-sm"
            ></textarea>

            {/* Interests */}
            <div className="mt-4">
              <p className="text-m font-medium mb-2 text-gray-600">
                I’m interested in
              </p>
              <div className="flex flex-wrap gap-2">
                {interests.map((item, index) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() => toggleInterest(item)}
                    className={`px-3 py-1.5 rounded-md text-xs font-medium border border-gray-300 ${
                      selectedInterests.includes(item)
                        ? "bg-gray-500 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-300"
                    } transition duration-300`}
                  >
                    {item}
                  </button>
                ))}
              </div>
            </div>

            {/* Submit */}
            <div className="flex justify-start mt-4">
              <button
                type="submit"
                className="px-3 py-2 border border-gray-500 text-white rounded-md text-xs tracking-wide bg-black hover:bg-gray-500 hover:text-white transition duration-300"
              >
                SUBMIT
              </button>
            </div>
          </form>

          {/* Status Messages */}
          {formStatus === "success" && (
            <p className="text-green-600 text-xs mt-2 font-medium">
              ✅ Thank you! Your inquiry has been submitted.
            </p>
          )}
          {formStatus === "error" && (
            <p className="text-red-600 text-xs mt-2 font-medium">
              ❌ Something went wrong. Please try again later.
            </p>
          )}
        </div>
      </aside>
    </>
  );
}
